import { isValidPort } from '../../utilities'

export default function getMidiPorts(access, callback) {
  const ports = [{ value: 'none', label: 'None', disabled: false }]
  access.outputs.forEach(port => {
    if (!isValidPort(port.name)) { // ignore K-Board
      if (window._debug === 'midithru') console.log('>> get ports:', port.name, port.type)
      ports.push({
        value: port.name,
        label: port.name,
        port: port
      })
      // explicitly open port to send without implicit open
      port.open()
    }
  })
  // update port list in preferences
  callback()

  // return array for window.midithruports
  return ports
}
